import { RadioGroup } from '@redis-ui/components';
import { RadioButtonGroupProps } from './RadioButtonGroup.types';

const RadioButtonGroup = <T extends string>({
  name,
  items,
  ...restProps
}: RadioButtonGroupProps<T>) => (
  <RadioGroup
    layout="horizontal"
    data-testid={`radio-button-group-${name}`}
    {...restProps}
    items={items.map(({ testIdSuffix, ...params }) => ({
      ...params,
      value: params.id,
      'data-testid': testIdSuffix ? `radiobutton--${testIdSuffix}` : undefined
    }))}
  />
);

export default RadioButtonGroup;
